<template>
  <div class="consider__plan__form" id="pdf">
    <div class="text-start mb-4 to-hide">
      <div class="font-32 font-w-700 font-ch">ผลพิจารณา</div>
      <div class="font-20 font-w-700 font-ch">
        แบบฟอร์มคําร้องขอใช้พื้นที่
      </div>
    </div>

    <v-layout justify-end mb-4 class="to-hide">
      <v-flex shrink mr-4>
        <v-btn
          color="#e51610"
          outlined
          rounded
          depressed
          @click.native="print()"
        >
          <Iconify
            style="color: #e51610"
            icon="fluent:document-pdf-24-filled"
          ></Iconify>
          <span style="color: #e51610">Export PDF </span>
        </v-btn>
      </v-flex>
      <v-flex shrink>
        <v-btn color="#5CB844" rounded depressed dark @click="onExportExcel()">
          <Iconify style="color: #fff" icon="ri:file-excel-2-fill"></Iconify>
          <span style="color: #fff">Export Excel </span>
        </v-btn>
      </v-flex>
    </v-layout>

    <!--PRINT HEADER-->
    <div
      class="to-show py-5"
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 14px;
        display: none;
        visibility: hidden;
        height: 0px;
        width: 750px;
      "
    >
      <div class="txt-head" style="text-align: center">ผลพิจารณา</div>
    </div>

    <v-card flat class="pa-6 section_form mb-3">
      <!-- รหัสแผนงาน -->
      <v-layout align-center class="font-14 font-w-500 font-ch mb-4">
        <v-flex xs2>
          <span class="mr-2">บริษัท</span>
        </v-flex>
        <v-flex xs2>
          <span class="text__orange">
            {{ form?.area_form_2?.company_name_th }}
          </span>
        </v-flex>
      </v-layout>

      <!-- ภูมิภาค -->
      <v-layout align-center class="font-14 font-w-500 font-ch mb-4">
        <v-flex xs2>
          <span class="mr-2">ภูมิภาค</span>
        </v-flex>
        <v-flex xs2>
          <span class="text__orange">{{ form?.region }}</span>
        </v-flex>
        <v-flex shrink>
          ผู้พิจารณา
          <span class="text__orange px-3"
            >{{ form?.evaluate_forms.length }}
          </span>
          ท่าน
        </v-flex>
      </v-layout>

      <!-- คะแนนเฉลี่ยรวม -->
      <v-layout align-center class="font-14 font-w-500 font-ch mb-4">
        <v-flex xs2>
          <span class="mr-2">คะแนนเฉลี่ยรวม</span>
        </v-flex>
        <v-flex xs2>
          <span class="text__orange"
            >{{ sumTotalScore() }}/{{
            form?.evaluate_layout?.overall_score
            }}</span
          >
        </v-flex>
      </v-layout>
    </v-card>

    <!-- Table -->
    <v-card flat class="pa-6 section_form mb-3" v-if="form">
      <table class="custom_table">
        <thead>
          <tr>
            <th
              class="text-center font-12"
              style="border-right: thin solid #d3d3d3"
              width="5%"
            >
              ลำดับ
            </th>
            <th
              class="text-center font-12"
              style="border-right: thin solid #d3d3d3"
              width="50%"
            >
              ประเภท/รายละเอียด
            </th>
            <th
              class="text-center font-12"
              style="border-right: thin solid #d3d3d3"
              width="10%"
            >
              คะเเนนเต็ม
            </th>
            <th
              class="text-center font-12 header_link"
              style="border-right: thin solid #d3d3d3"
              width="5%"
              @click="onViewConsiderForm(0)"
            >
              ผชช.1
            </th>
            <th
              class="text-center font-12 header_link"
              style="border-right: thin solid #d3d3d3"
              width="5%"
              @click="onViewConsiderForm(1)"
            >
              ผชช.2
            </th>
            <th
              class="text-center font-12 header_link"
              style="border-right: thin solid #d3d3d3"
              width="5%"
              @click="onViewConsiderForm(2)"
            >
              ผชช.3
            </th>
            <th
              class="text-center font-12 header_link"
              style="border-right: thin solid #d3d3d3"
              width="5%"
              @click="onViewConsiderForm(3)"
            >
              ผชช.4
            </th>
            <th
              class="text-center font-12 header_link"
              style="border-right: thin solid #d3d3d3"
              width="5%"
              @click="onViewConsiderForm(4)"
            >
              ผชช.5
            </th>
            <th class="text-center font-12" width="10%">คะแนนเฉลี่ย</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, i) in form?.evaluate_layout.details"
            :key="i"
            style="vertical-align: top"
          >
            <!-- ลำดับ -->
            <td
              class="text-center py-3"
              style="
                border-right: thin solid #d3d3d3;
                border-bottom: 1px solid #d3d3d3;
              "
              width="5%"
            >
              {{ i + 1 }}.
            </td>

            <!-- ประเภท/รายละเอียด -->
            <td
              style="
                border-right: thin solid #d3d3d3;
                border-bottom: 1px solid #d3d3d3;
              "
              width="50%"
              class="py-3"
            >
              <!-- main detail -->
              <div style="height: 40px">{{ item.name }}</div>
              <!-- sub detail -->
              <div
                v-for="(sub, j) in item.sub_details"
                :key="j"
                class="d-flex align-center"
                :class="isPrintPDF ? 'sub_detail_active' : 'sub_detail'"
              >
                <div>
                  <span class="mr-2">{{ i + 1 }}.{{ j + 1 }}</span>
                  <span>{{ sub.name }}</span>
                </div>
              </div>
            </td>

            <!-- คะเเนนเต็ม -->
            <td
              class="text-center py-3"
              style="
                border-right: thin solid #d3d3d3;
                border-bottom: 1px solid #d3d3d3;
              "
              width="5%"
            >
              <!-- main detail -->
              <div style="height: 40px" class="text__orange">
                {{ item.max_score }}
              </div>
              <!-- sub detail -->
              <div
                v-for="(sub, j) in item.sub_details"
                :key="j"
                class="text-center d-flex align-center justify-center"
                :class="isPrintPDF ? 'sub_detail_active' : 'sub_detail'"
              >
                <span>{{ sub.max_score }}</span>
              </div>
            </td>

            <!-- ผชช.1 -->
            <td
              class="text-center py-3"
              style="
                border-right: thin solid #d3d3d3;
                border-bottom: 1px solid #d3d3d3;
              "
              width="5%"
            >
              <!-- main detail -->
              <div style="height: 40px">
                {{
                  form?.evaluate_forms.length > 0 &&
                  form?.evaluate_forms[0]?.details[i]?.sub_details?.length == 0
                    ? form?.evaluate_forms[0]?.details[i]?.score
                    : ""
                }}
              </div>
              <!-- sub detail -->
              <div
                v-for="(sub, j) in item.sub_details"
                :key="j"
                class="text-center d-flex align-center justify-center"
                :class="isPrintPDF ? 'sub_detail_active' : 'sub_detail'"
              >
                <span v-if="form?.evaluate_forms.length > 0">
                  {{
                    form?.evaluate_forms[0]?.details[i]?.sub_details[j]?.score
                  }}
                </span>
              </div>
            </td>

            <!-- ผชช.2 -->
            <td
              class="text-center py-3"
              style="
                border-right: thin solid #d3d3d3;
                border-bottom: 1px solid #d3d3d3;
              "
              width="5%"
            >
              <!-- main detail -->
              <div style="height: 40px">
                {{
                  form?.evaluate_forms.length > 0 &&
                  form?.evaluate_forms[1]?.details[i]?.sub_details?.length == 0
                    ? form?.evaluate_forms[1]?.details[i]?.score
                    : ""
                }}
              </div>
              <!-- sub detail -->
              <div
                v-for="(sub, j) in item.sub_details"
                :key="j"
                class="text-center d-flex align-center justify-center"
                :class="isPrintPDF ? 'sub_detail_active' : 'sub_detail'"
              >
                <span v-if="form?.evaluate_forms.length > 0">
                  {{
                    form?.evaluate_forms[1]?.details[i]?.sub_details[j]?.score
                  }}
                </span>
              </div>
            </td>

            <!-- ผชช.3 -->
            <td
              class="text-center py-3"
              style="
                border-right: thin solid #d3d3d3;
                border-bottom: 1px solid #d3d3d3;
              "
              width="5%"
            >
              <!-- main detail -->
              <div style="height: 40px">
                {{
                  form?.evaluate_forms.length > 0 &&
                  form?.evaluate_forms[2]?.details[i]?.sub_details?.length == 0
                    ? form?.evaluate_forms[2]?.details[i]?.score
                    : ""
                }}
              </div>
              <!-- sub detail -->
              <div
                v-for="(sub, j) in item.sub_details"
                :key="j"
                class="text-center d-flex align-center justify-center"
                :class="isPrintPDF ? 'sub_detail_active' : 'sub_detail'"
              >
                <span v-if="form?.evaluate_forms.length > 0">
                  {{
                    form?.evaluate_forms[2]?.details[i]?.sub_details[j]?.score
                  }}
                </span>
              </div>
            </td>

            <!-- ผชช.4 -->
            <td
              class="text-center py-3"
              style="
                border-right: thin solid #d3d3d3;
                border-bottom: 1px solid #d3d3d3;
              "
              width="5%"
            >
              <!-- main detail -->
              <div style="height: 40px">
                {{
                  form?.evaluate_forms.length > 0 &&
                  form?.evaluate_forms[3]?.details[i]?.sub_details?.length == 0
                    ? form?.evaluate_forms[3]?.details[i]?.score
                    : ""
                }}
              </div>
              <!-- sub detail -->
              <div
                v-for="(sub, j) in item.sub_details"
                :key="j"
                class="text-center d-flex align-center justify-center"
                :class="isPrintPDF ? 'sub_detail_active' : 'sub_detail'"
              >
                <span v-if="form?.evaluate_forms.length > 0">
                  {{
                    form?.evaluate_forms[3]?.details[i]?.sub_details[j]?.score
                  }}
                </span>
              </div>
            </td>

            <!-- ผชช.5 -->
            <td
              class="text-center py-3"
              style="
                border-right: thin solid #d3d3d3;
                border-bottom: 1px solid #d3d3d3;
              "
              width="5%"
            >
              <!-- main detail -->
              <div style="height: 40px">
                {{
                  form?.evaluate_forms.length > 0 &&
                  form?.evaluate_forms[4]?.details[i]?.sub_details?.length == 0
                    ? form?.evaluate_forms[4]?.details[i]?.score
                    : ""
                }}
              </div>
              <!-- sub detail -->
              <div
                v-for="(sub, j) in item.sub_details"
                :key="j"
                class="text-center d-flex align-center justify-center"
                :class="isPrintPDF ? 'sub_detail_active' : 'sub_detail'"
              >
                <span v-if="form?.evaluate_forms.length > 0">
                  {{
                    form?.evaluate_forms[4]?.details[i]?.sub_details[j]?.score
                  }}
                </span>
              </div>
            </td>

            <!-- คะเเนนเฉลี่ย -->
            <td
              class="text-center"
              width="10%"
              style="border-bottom: 1px solid #d3d3d3"
            >
              <!-- main detail -->
              <div style="height: 40px">
                {{
                  form?.evaluate_forms.length > 0 &&
                  form?.evaluate_forms[0]?.details[i]?.sub_details?.length ==
                    0 &&
                  form?.evaluate_forms[1]?.details[i]?.sub_details?.length ==
                    0 &&
                  form?.evaluate_forms[2]?.details[i]?.sub_details?.length ==
                    0 &&
                  form?.evaluate_forms[3]?.details[i]?.sub_details?.length ==
                    0 &&
                  form?.evaluate_forms[4]?.details[i]?.sub_details?.length == 0
                    ? avgEvaluateFormDetail(
                        form?.evaluate_forms[0]?.details[i]?.score,
                        form?.evaluate_forms[1]?.details[i]?.score,
                        form?.evaluate_forms[2]?.details[i]?.score,
                        form?.evaluate_forms[3]?.details[i]?.score,
                        form?.evaluate_forms[4]?.details[i]?.score
                      )
                    : ""
                }}
              </div>
              <!-- sub detail -->
              <div
                v-for="(sub, j) in item.sub_details"
                :key="j"
                class="text-center d-flex align-center justify-center"
                :class="isPrintPDF ? 'sub_detail_active' : 'sub_detail'"
              >
                {{
                  form?.evaluate_forms.length > 0
                    ? avgEvaluateFormSubDetail(
                        form?.evaluate_forms[0]?.details[i]?.sub_details[j]
                          ?.score,
                        form?.evaluate_forms[1]?.details[i]?.sub_details[j]
                          ?.score,
                        form?.evaluate_forms[2]?.details[i]?.sub_details[j]
                          ?.score,
                        form?.evaluate_forms[3]?.details[i]?.sub_details[j]
                          ?.score,
                        form?.evaluate_forms[4]?.details[i]?.sub_details[j]
                          ?.score
                      )
                    : ""
                }}
              </div>
            </td>
          </tr>

          <!-- รวมคะเเนน -->
          <tr>
            <td style="border-right: thin solid #d3d3d3"></td>
            <td style="border-right: thin solid #d3d3d3" class="text-center">
              <span class="mr-2">รวมคะเเนน</span>
            </td>
            <td style="border-right: thin solid #d3d3d3" class="text-center">
              <span class="text__orange">
                {{ form?.evaluate_layout?.overall_score }}
              </span>
            </td>
            <td style="border-right: thin solid #d3d3d3" class="text-center">
              {{ sumScore(0) }}
            </td>
            <td style="border-right: thin solid #d3d3d3" class="text-center">
              {{ sumScore(1) }}
            </td>
            <td style="border-right: thin solid #d3d3d3" class="text-center">
              {{ sumScore(2) }}
            </td>
            <td style="border-right: thin solid #d3d3d3" class="text-center">
              {{ sumScore(3) }}
            </td>
            <td style="border-right: thin solid #d3d3d3" class="text-center">
              {{ sumScore(4) }}
            </td>
            <td class="text-center">
              {{ numberDecimal(sum_result) }}
            </td>
          </tr>
        </tbody>
      </table>
    </v-card>

    <div class="font-14 font-w-500 font-ch mb-5" style="color: #f15a29">
      หมายเหตุ : แบบประเมินหากทำการลงคะเเนนแล้วไม่สามารถแก้ไขได้
    </div>
  </div>
</template>

<script>
import Service from "../../services";
import { Icon } from "@iconify/vue2";
import * as XLSX from "xlsx";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "ConsiderResultAF",
  components: {
    Icon,
  },
  data() {
    return {
      form: null,

      sum_result: 0,
      isPrintPDF: false,
    };
  },

  computed: {
    ...mapState({
      isLoading: (state) => state.General.isLoading,
      userInfo: (state) => state.Auth.User,
    }),
  },
  created() {
    this.fetchForm();
  },
  methods: {
    fetchForm() {
      Service.Consider.getEvaluateSummaryAF(this.$route.params.area_form_id).then(
        (res) => {
          ///log res
          console.log(res,'res');
          this.form = res.data.data;
          console.log(this.form,'this.form');
          console.log(this.form?.evaluate_layout.details,'this.form2');

          // sum result
          this.form?.evaluate_layout?.details.forEach((detail, i) => {
            if (this.form?.evaluate_forms.length > 0) {
              this.sum_result += parseFloat(
                this.avgEvaluateFormDetail(
                  Number(this.form?.evaluate_forms[0]?.details[i]?.score) || 0,
                  Number(this.form?.evaluate_forms[1]?.details[i]?.score) || 0,
                  Number(this.form?.evaluate_forms[2]?.details[i]?.score) || 0,
                  Number(this.form?.evaluate_forms[3]?.details[i]?.score) || 0,
                  Number(this.form?.evaluate_forms[4]?.details[i]?.score) || 0,
                )
              );
            }
          });
        }
      );
    },
    avgEvaluateFormDetail(val1 = 0, val2 = 0, val3 = 0, val4 = 0, val5 = 0) {

      val1 = Number(val1);
      val2 = Number(val2);
      val3 = Number(val3);
      val4 = Number(val4);
      val5 = Number(val5);
      return this.form.evaluate_forms.length > 0
        ? (
            (val1 + val2 + val3 + val4 + val5) /
            this.form.evaluate_forms.length
          ).toFixed(2)
        : "";
    },
    avgEvaluateFormSubDetail(val1 = 0, val2 = 0, val3 = 0, val4 = 0, val5 = 0) {
      val1 = Number(val1);
      val2 = Number(val2);
      val3 = Number(val3);
      val4 = Number(val4);
      val5 = Number(val5);

      const sum = (val1 + val2 + val3 + val4 + val5) / this.form.evaluate_forms.length;

      return parseFloat(sum.toFixed(2)).toFixed(2);
    },
    sumTotalScore() {
      let sum = 0;
      this.form?.evaluate_forms?.forEach((item, index) => {
        sum += parseFloat(item.total_score);
      });
      return sum == 0 ? "" : (sum / this.form.evaluate_forms.length).toFixed(2);
    },
    sumScore(index) {
      let sum = 0;
      if (this.form?.evaluate_forms.length > 0) {
        this.form?.evaluate_layout.details.forEach((item, i) => {
          if (this.form?.evaluate_forms[index]) {
            sum += parseFloat(
              this.form.evaluate_forms[index]?.details[i]?.score
            );
          }
        });
      }

      return sum == 0 ? "" : sum;
    },
    onViewConsiderForm(index) {
      if (this.form.evaluate_forms[index]) {
        this.$router.push({
          name: "EvaluateView",
          params: {
            id: this.form.evaluate_forms[index].id,
          },
          query: { formType: 'area-form' },
        });
      }
    },
    numberDecimal(val) {
      const val2 = Number(val);
      
      return val2.toFixed(2);
    },

    onExportExcel() {
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet([]);

      // แผนงาน
      const jsonExcelSection1 = [
        {
          แผนงาน: this.form?.evaluate_layout.plan_master?.plan_name_th,
          รหัสแผนงาน: this.form?.evaluate_layout.plan_master?.plan_code,
          โครงการ: this.form?.evaluate_layout.main_project?.name,
          ภูมิภาค: this.form?.region,
          จำนวนผู้พิจารณา: this.form?.evaluators?.length,
          "คะแนนเฉลี่ยรวม /100":
          this.form?.evaluate_layout?.overall_score,
        },
      ];
      XLSX.utils.sheet_add_json(worksheet, jsonExcelSection1, {
        origin: "A1",
      });

      // ตารางคะแนน
      let jsonExcelSection2 = [];
      this.form?.evaluate_layout.details.forEach((detail, i) => {
        // main detail
        jsonExcelSection2.push({
          ลำดับ: i + 1,
          "ประเภท/รายละเอียด": detail.name,
          รายละเอียดย่อย: "",
          คะเเนนเต็ม: detail.max_score,
          "ผชช.1":
            this.form?.evaluate_forms.length > 0 &&
            this.form?.evaluate_forms[0]?.details[i]?.sub_details?.length == 0
              ? this.form?.evaluate_forms[0]?.details[i]?.score
              : "",
          "ผชช.2":
            this.form?.evaluate_forms.length > 0 &&
            this.form?.evaluate_forms[1]?.details[i]?.sub_details?.length == 0
              ? this.form?.evaluate_forms[1]?.details[i]?.score
              : "",
          "ผชช.3":
            this.form?.evaluate_forms.length > 0 &&
            this.form?.evaluate_forms[2]?.details[i]?.sub_details?.length == 0
              ? this.form?.evaluate_forms[2]?.details[i]?.score
              : "",
          "ผชช.4":
            this.form?.evaluate_forms.length > 0 &&
            this.form?.evaluate_forms[3]?.details[i]?.sub_details?.length == 0
              ? this.form?.evaluate_forms[3]?.details[i]?.score
              : "",
          "ผชช.5":
            this.form?.evaluate_forms.length > 0 &&
            this.form?.evaluate_forms[4]?.details[i]?.sub_details?.length == 0
              ? this.form?.evaluate_forms[4]?.details[i]?.score
              : "",
          คะเเนนเฉลี่ย:
            this.form?.evaluate_forms.length > 0 &&
            this.form?.evaluate_forms[0]?.details[i]?.sub_details?.length ==
              0 &&
            this.form?.evaluate_forms[1]?.details[i]?.sub_details?.length ==
              0 &&
            this.form?.evaluate_forms[2]?.details[i]?.sub_details?.length ==
              0 &&
            this.form?.evaluate_forms[3]?.details[i]?.sub_details?.length ==
              0 &&
            this.form?.evaluate_forms[4]?.details[i]?.sub_details?.length == 0
              ? this.avgEvaluateFormDetail(
                  this.form?.evaluate_forms[0]?.details[i]?.score,
                  this.form?.evaluate_forms[1]?.details[i]?.score,
                  this.form?.evaluate_forms[2]?.details[i]?.score,
                  this.form?.evaluate_forms[3]?.details[i]?.score,
                  this.form?.evaluate_forms[4]?.details[i]?.score
                )
              : "",
        });

        // sub detail
        detail.sub_details.forEach((sub_detail, j) => {
          jsonExcelSection2.push({
            ลำดับ: "",
            "ประเภท/รายละเอียด": "",
            รายละเอียดย่อย: i + 1 + "." + (j + 1) + " " + sub_detail.name,
            คะเเนนเต็ม: sub_detail.max_score,
            "ผชช.1":
              this.form?.evaluate_forms[0]?.details[i]?.sub_details[j]?.score,
            "ผชช.2":
              this.form?.evaluate_forms[1]?.details[i]?.sub_details[j]?.score,
            "ผชช.3":
              this.form?.evaluate_forms[2]?.details[i]?.sub_details[j]?.score,
            "ผชช.4":
              this.form?.evaluate_forms[3]?.details[i]?.sub_details[j]?.score,
            "ผชช.5":
              this.form?.evaluate_forms[4]?.details[i]?.sub_details[j]?.score,
            คะเเนนเฉลี่ย:
              this.form?.evaluate_forms.length > 0
                ? this.avgEvaluateFormSubDetail(
                    this.form?.evaluate_forms[0]?.details[i]?.sub_details[j]
                      ?.score,
                    this.form?.evaluate_forms[1]?.details[i]?.sub_details[j]
                      ?.score,
                    this.form?.evaluate_forms[2]?.details[i]?.sub_details[j]
                      ?.score,
                    this.form?.evaluate_forms[3]?.details[i]?.sub_details[j]
                      ?.score,
                    this.form?.evaluate_forms[4]?.details[i]?.sub_details[j]
                      ?.score
                  )
                : "",
          });
        });
      });

      jsonExcelSection2.push({
        ลำดับ: this.form?.evaluate_layout.details.length + 1,
        "ประเภท/รายละเอียด": "รวม",
        รายละเอียดย่อย: "",
        คะเเนนเต็ม:this.form?.evaluate_layout?.overall_score,
        "ผชช.1": this.sumScore(0),
        "ผชช.2": this.sumScore(1),
        "ผชช.3": this.sumScore(2),
        "ผชช.4": this.sumScore(3),
        "ผชช.5": this.sumScore(4),
        คะเเนนเฉลี่ย:
          this.numberDecimal(this.sum_result) == "0.00"
            ? ""
            : this.numberDecimal(this.sum_result),
      });

      XLSX.utils.sheet_add_json(worksheet, jsonExcelSection2, {
        origin: "G1",
      });

      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
      let fileName = `consider_result.xlsx`;
      XLSX.writeFile(workbook, fileName);
    },
    print() {
      this.isPrintPDF = true;
      setTimeout(() => {
        //get current date dd-mm-yyyy
        let today = new Date();
        let dd = today.getDate();
        let mm = today.getMonth() + 1;
        let yyyy = today.getFullYear();
        if (dd < 10) {
          dd = "0" + dd;
        }
        if (mm < 10) {
          mm = "0" + mm;
        }
        today = dd + "-" + mm + "-" + yyyy;

        //change document title
        document.title =
          "Evaluate_Result_" +
          this.userInfo.user_type +
          "_" +
          this.form?.evaluate_layout.plan_master?.plan_code +
          "_" +
          today;
        let toHide = document.getElementsByClassName("to-hide");
        let pdfPage = document.getElementById("pdf");
        let mainContent = document.getElementById("main");
        let titled = document.getElementsByClassName("titled");
        let toShow = document.getElementsByClassName("to-show");
        let noBoxShadow = document.getElementsByClassName("theme-card");
        let s3p1 = document.getElementsByClassName("s3-p1");
        let s3p1h = document.getElementsByClassName("s3-p1-h");
        let indent_info = document.getElementsByClassName("indent-info");

        //remove all class name indent-info
        for (let i = 0; i < indent_info.length; i++) {
          indent_info[i].style.paddingLeft = "10px";
        }

        //show toShow
        for (let i = 0; i < toShow.length; i++) {
          toShow[i].style.display = "block";
          toShow[i].style.visibility = "visible";
          toShow[i].style.height = "auto";
        }

        //hide toHide
        for (let i = 0; i < toHide.length; i++) {
          toHide[i].style.display = "none";
          toHide[i].style.visibility = "hidden";
        }
        for (let i = 0; i < titled.length; i++) {
          titled[i].style.boxShadow = "none";

          //set box shadow to every child of titled
          let titledChild = titled[i].children;
          for (let j = 0; j < titledChild.length; j++) {
            titledChild[j].style.boxShadow = "none";
          }
        }

        //set no-box-shadow box-shadow to none
        for (let i = 0; i < noBoxShadow.length; i++) {
          noBoxShadow[i].style.boxShadow = "none";

          //set border
          noBoxShadow[i].style.border = "1px solid #F5F5F5";
        }

        //set s3p1 style scale 0.8
        for (let i = 0; i < s3p1.length; i++) {
          s3p1[i].style.transform = "scale(0.75)";
          s3p1[i].style.transformOrigin = "top left";
          s3p1[i].style.alignItems = "flex-start";

          //remove class overflow-x-auto
          s3p1[i].classList.remove("overflow-x-auto");
        }
        //set s3p1h style height
        for (let i = 0; i < s3p1h.length; i++) {
          s3p1h[i].style.height = "auto";
        }

        // pdfPage.style.minWidth = '600px'
        pdfPage.style.width = "750px";
        mainContent.style.paddingLeft = 0;
        mainContent.style.backgroundColor = "#fff";

        window.print();
        //reload
        window.location.reload();
      }, 500);
    },
  },
};
</script>

<style lang="scss">
.consider__plan__form {
  .section_form {
    background: #ffffff;
    box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1) !important;
    border-radius: 20px;
  }
  .text__orange {
    color: #f15a29;
  }
  .custom_table {
    border: thin solid #d3d3d3;
    .sub_detail {
      min-height: 60px;
    }
    .sub_detail_active {
      min-height: 100px;
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }

  input[type="number"] {
    -moz-appearance: textfield; /* Firefox */
  }
  .btn_orange_gradient {
    background: linear-gradient(21.01deg, #f15a29 6.18%, #fbb040 84.83%);
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
  }
  .v-text-field__slot {
    input {
      text-align: center !important;
    }
  }
  .custom_table {
    width: 100%;
    border-spacing: 0px;
    th {
      padding: 10px;
      border-bottom: 1px solid #d3d3d3;
    }
    td {
      padding: 10px;
    }
  }

  .header_link:hover {
    color: #f15a29;
    cursor: pointer;
  }
}
@page {
  size: A4 portrait;
  margin: 1mm 1mm 1mm 1mm;
}
</style>
